module.exports = __webpack_public_path__ + "src/assets/img/user_role_cus.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/user_role_cus.svg
// module id = GmU4
// module chunks = 80